import { CourseService, EnrollmentService, SubscriptionService } from '../_index';

import { AuthModule } from './auth/auth.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { UserAdapter } from '@app/adapters/_index';
import { EnrollmentAdapter } from '@app/adapters/enrollment.adapter';
import { SubscriptionAdapter } from '@app/adapters/subscription.adapter';
import { SubscriptionFactory } from '@app/factories/subscription.factory';
import { UserService } from './user.service';

@NgModule({
  imports: [AuthModule],
})
export class UserModule {
  static forRoot(): ModuleWithProviders<UserModule> {
    return {
      ngModule: UserModule,
      providers: [
        UserService,
        CourseService,
        EnrollmentAdapter,
        EnrollmentService,
        SubscriptionAdapter,
        SubscriptionService,
        SubscriptionFactory,
        UserAdapter,
      ],
    };
  }
}
